module.exports = __webpack_public_path__ + "static/text-547438616c91ecb0d33b0873f6d42589.png";